var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page-wrapper viewQuotes-wrap"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('breadcrumb', {
    attrs: {
      "items": _vm.breadcrumbItems
    }
  }), _c('div', {
    staticClass: "page-title"
  }, [_c('h1', [_vm._v("Personalized Quoting System (PQS)")]), _c('button', {
    staticClass: "clear-search",
    on: {
      "click": _vm.clearSearch
    }
  }, [_vm._v("Clear Search")])]), _c('div', {
    staticClass: "pqs-tabs titleTab mt-3"
  }, [_c('div', {
    staticClass: "quote-type-btns"
  }, [_c('button', {
    staticClass: "view-quote-btn",
    class: {
      active: _vm.activeListName == 'individual'
    },
    on: {
      "click": _vm.viewIndividualQuotes
    }
  }, [_vm._v(" View Individual Quote ")]), _c('button', {
    staticClass: "view-quote-btn",
    class: {
      active: _vm.activeListName == 'group'
    },
    on: {
      "click": _vm.viewGroupQuotes
    }
  }, [_vm._v(" View Group Quote ")])]), _c('div', {
    staticClass: "quote-action-btns"
  }, [_vm.activeListName == 'individual' ? _c('button', {
    staticClass: "new-quote-btn individual-new-quote-btn mt-0 new-quote px-3",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.renderPersonalizedModal.apply(null, arguments);
      }
    }
  }, [_vm._v(" + Quote Individual Client ")]) : _vm._e(), _vm.activeListName == 'group' ? _c('button', {
    staticClass: "new-quote-btn px-3 mt-0 new-quote",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.renderPQSQuote.apply(null, arguments);
      }
    }
  }, [_vm._m(0), _c('span', [_vm._v(" PQS - Groups ")])]) : _vm._e(), _vm.activeListName == 'group' ? _c('button', {
    staticClass: "new-quote-btn mt-0 px-3 new-quote",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.renderGroupQouteModal.apply(null, arguments);
      }
    }
  }, [_vm._v(" + Quote Group Client ")]) : _vm._e()])]), _c('quote-filter', {
    attrs: {
      "filters": _vm.quoteFilters
    },
    on: {
      "onSearch": _vm.getFilteredRecords
    }
  }), _c('div', {
    staticClass: "quote-card pt-3"
  }, [_c('div', {
    staticClass: "top-pagination"
  }, [_c('div', {
    staticClass: "view-quote-pagination"
  }, [_vm.activeListName == 'group' ? _c('pagination', {
    attrs: {
      "rows": _vm.computedGroupQuotes,
      "filters": _vm.quoteFilters
    },
    on: {
      "update:rows": function updateRows($event) {
        _vm.computedGroupQuotes = $event;
      }
    }
  }) : _vm._e(), _vm.activeListName == 'individual' ? _c('pagination', {
    attrs: {
      "rows": _vm.quoteList,
      "filters": _vm.quoteFilters
    },
    on: {
      "update:rows": function updateRows($event) {
        _vm.quoteList = $event;
      }
    }
  }) : _vm._e()], 1)]), _vm.activeListName == 'individual' ? _c('div', [_c('quote-list', {
    attrs: {
      "quoteList": _vm.quoteList
    },
    on: {
      "reloadQuotes": _vm.reloadQuotes
    }
  }), _c('pagination', {
    attrs: {
      "rows": _vm.quoteList,
      "filters": _vm.quoteFilters
    },
    on: {
      "update:rows": function updateRows($event) {
        _vm.quoteList = $event;
      }
    }
  })], 1) : _vm._e(), _vm.activeListName == 'group' ? _c('div', [_c('group-census-table', {
    attrs: {
      "groupCensusList": _vm.computedGroupQuotes
    },
    on: {
      "reloadQuotes": _vm.reloadQuotes
    }
  }), _c('pagination', {
    attrs: {
      "rows": _vm.computedGroupQuotes,
      "filters": _vm.quoteFilters
    },
    on: {
      "update:rows": function updateRows($event) {
        _vm.computedGroupQuotes = $event;
      }
    }
  })], 1) : _vm._e()])], 1)]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('span', [_c('img', {
    attrs: {
      "src": require("../../assets/images/groupQuote.svg"),
      "width": "25",
      "height": "17"
    }
  })]);
}]

export { render, staticRenderFns }